"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenHistory = void 0;
var TokenHistoryList_1 = require("./TokenHistoryList");
var TokenHistory = /** @class */ (function () {
    function TokenHistory(data) {
        this.displayTicketNumber = null;
        this.playable = data.playable;
        this.ticketEntry = data.ticketEntry;
        this.token = data.token;
    }
    TokenHistory.toJsonList = function (data) {
        var tokenHistoryList = new TokenHistoryList_1.TokenHistoryList();
        data.forEach(function (token) {
            tokenHistoryList.push(TokenHistory.toJson(token));
        });
        return tokenHistoryList.getFormattedData();
    };
    TokenHistory.toJson = function (data) { return new TokenHistory(data); };
    return TokenHistory;
}());
exports.TokenHistory = TokenHistory;
//# sourceMappingURL=TokenHistory.js.map